import Swiper from 'swiper'
import {Pagination, Navigation, Autoplay} from 'swiper/modules';


const swiperLst = [];

function initializeSliders() {

  [
    '.hh-testimonial-slider-block',
    '.hh-download-tiles-slider-block',
    '.hh-project-tiles-slider-block',
    '.hh-image-slider-block',
    '.hh-text-slider-block'
  ].forEach((parentSelector) => {

    let spaceBetween = 16;
    let autoHeight = false;

    if (parentSelector === '.hh-image-slider-block') {
      spaceBetween = 16;
    }

    if (['.hh-testimonial-slider-block', 'hh-text-slider-block'].includes(parentSelector)) {
      autoHeight = true;
    }


    const blocks = document.querySelectorAll(`${parentSelector}`) || [];

    [...blocks].filter((block) => block).forEach((block) => {

      const sliderItem = block?.querySelector(`.swiper`);
      const sliderItemPagination = block?.querySelector(`.swiper-pagination`);

      const tempSwiper = new Swiper(sliderItem, {
        modules: [Navigation, Pagination],
        autoHeight: false,
        observer: true,
        observeParents: true,
        slidesPerView: 1,
        speed: 500,
        spaceBetween,
        breakpoints: {
          640: {
            slidesPerView: 2,
            autoHeight,
          },
          1024: {
            slidesPerView: 3,
            autoHeight,

          },
        },
        pagination: {
          el: sliderItemPagination,
        },

        // Navigation arrows
        navigation: {
          nextEl: block?.querySelector(`.swiper-button-next`),
          prevEl: block?.querySelector(`.swiper-button-prev`),
        },

        on: {
          init() {
          },
        },
      })

      swiperLst.push(tempSwiper);
    })

  })
}

initializeSliders();

let timeoutId = null;
window.addEventListener('resize', () => {

  clearTimeout(timeoutId);
  timeoutId = setTimeout(() => {
    swiperLst.forEach((swiperItem) => {
      if (swiperItem.wrapperEl) {
        swiperItem.updateAutoHeight();
        swiperItem.updateSize();
      }
    })
  }, 150);
});


let headerTimeoutId = null;


function handleScroll() {
  clearTimeout(headerTimeoutId);


  headerTimeoutId = setTimeout(() => {
    const header = document.querySelector('.header-banner');
    console.log(window.scrollY);

    if (window.scrollY > 61) {
      header.classList.add('d-none');
    }

    if (window.scrollY < 60 ) {
      header.classList.remove('d-none');
    }
  }, 1000);
}

handleScroll();
// Add event listener
window.addEventListener('scroll', handleScroll);